import {
	Component
} from '@angular/core'

@Component({
	selector: 'about-us',
	templateUrl: '../views/about-us.component.html'
})

export class AboutUsComponent{

}


// WEBPACK FOOTER //
// D:/Projects/GitHub/gvrogers/src/app/components/about-us.component.ts